// ============================================
// CONFIG/IVA.JS — Fuente unica de la tasa de IVA (frontend)
// ============================================
// Centraliza la tasa para no repetir el literal 0.16 / 1.16 por todo el codigo.
// IMPORTANTE: FACTOR_IVA es su PROPIO literal 1.16, NO se calcula como
// (1 + TASA_IVA): en coma flotante 1 + 0.16 NO es identico a 1.16 y eso
// cambiaria resultados (golden-master). Mantener ambos como literales.

export const TASA_IVA = 0.16;
export const FACTOR_IVA = 1.16;
